import { Directive, createApp } from "vue";
import NSFW from "./index.vue";
import { useGlobalUser } from "@/stores/globalUser";

export const nsfw: Directive = {
  mounted(el, binding) {
    const app = createApp(NSFW);
    const ins = app.mount(document.createElement("div"));
    el.instance = ins;
    const u = useGlobalUser();
    if (binding.value && (u.isCNUser || !u.user.isNsfwVisible)) appendEl(el);
  },
  updated(el, binding) {
    const u = useGlobalUser();
    if (u.isCNUser || !u.user.isNsfwVisible) return;
    if (binding.value !== binding.oldValue)
      binding.value ? appendEl(el) : removeEl(el);
  },
};

const appendEl = (el: any) => el.appendChild(el.instance.$el);

const removeEl = (el: any) => el.instance.$el.remove();
